import "./style.css";
import { startGuestFlow, startPersonalizedGuestFlow } from "./guest";
import { startHostFlow } from "./host";
import { renderError } from "./ui";
import { resolveRoute } from "./route";

const container = document.getElementById("app");

if (!container) {
  throw new Error("Missing #app container element");
}

const params = new URLSearchParams(window.location.search);
const route = resolveRoute(
  window.location.pathname,
  params.get("authToken"),
  params.get("callType"),
);

switch (route.kind) {
  case "host":
    // Host flow: /room?authToken=<token>&callType=<video|audio>
    startHostFlow(route.authToken, route.callType, container);
    break;
  case "personalized-guest":
    // Personalized guest flow: /<meetingId>/<inviteeId> (backend-feathub#162)
    startPersonalizedGuestFlow(route.meetingId, route.inviteeId, container);
    break;
  case "anonymous-guest":
    // Anonymous guest flow: /<token>
    startGuestFlow(route.token, container);
    break;
  default:
    renderError(
      container,
      "Falta información en el enlace de la reunión. Solicita un nuevo enlace de acceso.",
    );
}
